<template>
  <ContentContainer :loadingStatus="isLoading">
    <div class="edit-room-type content-wrapper">
      <div class="page-header">{{ $t('emailConfiguration') }}</div>
      <el-container>
        <el-main>
          <el-form ref="form" label-width="150px" style="width: 600px">
            <el-form-item :label="$t('senderName')">
              <el-col :span="22">
                <el-input v-model="hotel.senderName"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item :label="$t('replyEmail')">
              <el-col :span="22">
                <el-input v-model="hotel.replyEmail"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item  :key="`ccEmail-${index}`" v-for="(ccEmail, index) in hotel.emailConfiguration.ccEmailList" :label="bindLabel(index, $t('ccEmail'))">
              <el-col :span="22">
                <el-input v-model="hotel.emailConfiguration.ccEmailList[index]"></el-input>
              </el-col>
              <el-col v-if="index > 0" :span="2" >
                <el-button type="danger" icon="el-icon-delete" circle @click="onRemoveItemButtonClick('ccEmailList', index)"></el-button>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-col :span="4"><el-button type="primary" size="mini" plain @click="onAddMoreItemButtonClick('ccEmailList')">{{$t('addCcEmail')}}</el-button></el-col>
              <el-col :span="20"></el-col>
            </el-form-item>
            <el-form-item  :key="`bccEmail-${index}`" v-for="(bccEmail, index) in hotel.emailConfiguration.bccEmailList" :label="bindLabel(index, $t('bccEmail'))">
              <el-col :span="22">
                <el-input v-model="hotel.emailConfiguration.bccEmailList[index]"></el-input>
              </el-col>
              <el-col v-if="index > 0" :span="2" >
                <el-button type="danger" icon="el-icon-delete" circle @click="onRemoveItemButtonClick('bccEmailList', index)"></el-button>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-col :span="4"><el-button type="primary" size="mini" plain @click="onAddMoreItemButtonClick('bccEmailList')">{{$t('addBccEmail')}}</el-button></el-col>
              <el-col :span="20"></el-col>
            </el-form-item>

            <el-form-item label="">
              <el-col :span="22">
                <el-button type="primary" @click="onSaveButtonClick">{{ $t('saveChanges') }}</el-button>
              </el-col>
            </el-form-item>
          </el-form>
        </el-main>
      </el-container>
    </div>
  </ContentContainer>
</template>

<script>
import { STATUS } from '@/configs/constant'
import i18nMessages from '@/translations/Hotel/ManageHotel/EmailConfiguration/Edit.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import HotelApi from '@/api/hotel-api'
import ContentContainer from '@/components/ContentContainerComponent.vue'
import LocalStorageFactory from '@/factories/local-storage-factory'
import { getHotelIndexRoute, getHotelInfo } from '@/services/hotel-service'
import { mapState } from 'vuex'
import { map, trim } from 'lodash'

export default {
  name: 'HotelEmailConfiguration',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { ContentContainer },
  i18n: { messages: i18nMessages },
  data () {
    return {
      isLoading: false,
      STATUS,
      hotel: {
        name: '',
        isEnable: STATUS.ENABLE,
        information: {
          address: '',
          emailList: [],
          phoneList: [],
          faxList: []
        },
        emailConfiguration: {
          senderName: '',
          replyEmail: '',
          ccEmailList: [],
          bccEmailList: []
        },
        remark: ''
      },
      deletedEmail: {
        ccEmailList: [],
        bccEmailList: []
      }
    }
  },
  created: async function () {
    this.isLoading = true

    if (this.activeHotelId === undefined || this.activeHotelId === '') {
      const companyDetail = LocalStorageFactory.getCompanyDetail()
      const routeName = await getHotelIndexRoute(companyDetail, this.$store)

      return this.$router.push({
        name: routeName
      })
    }

    try {
      await this.getHotelInfo(this.activeHotelId)
    } catch (err) {
      this.alertError(err.message)
    }

    this.isLoading = false
  },
  computed: {
    ...mapState({
      activeHotelId: state => state.general.activeHotelId
    })
  },
  watch: {
    activeHotelId: function (val) {
      this.getHotelInfo(val)
    }
  },
  methods: {
    getHotelInfo: async function (hotelId) {
      try {
        this.isLoading = true
        this.hotel = await getHotelInfo(hotelId)
        this.prepareInformation()
      } catch (err) {
        this.alertError(err.message)
      }

      this.isLoading = false
    },
    prepareInformation: function () {
      for (const key in this.hotel.emailConfiguration) {
        if (this.hotel.emailConfiguration[key].length <= 0) {
          this.hotel.emailConfiguration[key].push('')
        }
      }
    },
    bindLabel: function (index, defaultLabel) {
      return (index === 0) ? defaultLabel : ''
    },
    onAddMoreItemButtonClick: function (keyItem) {
      this.hotel.emailConfiguration[keyItem].push('')
    },
    onRemoveItemButtonClick: function (keyItem, index) {
      this.deletedEmail[keyItem].push(this.hotel.emailConfiguration[keyItem][index])
      this.hotel.emailConfiguration[keyItem].splice(index, 1)
    },
    onSaveButtonClick: async function () {
      try {
        this.startLoading()
        this.filterEmail()

        const tempHotelEmailConfiguration = this.hotel.emailConfiguration
        this.hotel.emailConfiguration = {
          ccEmailList: map(this.hotel.emailConfiguration.ccEmailList, trim),
          bccEmailList: map(this.hotel.emailConfiguration.bccEmailList, trim),
          deletedEmail: this.deletedEmail,
          senderName: this.hotel.senderName,
          replyEmail: this.hotel.replyEmail
        }
        await HotelApi.update(this.hotel.id, this.hotel)
        this.hotel.emailConfiguration = tempHotelEmailConfiguration
        const title = this.$t('saveEmailConfigurationSuccessTitle')
        const message = this.$t('saveEmailConfigurationSuccessMessage')

        await this.getHotelInfo(this.hotel.id)
        this.showNotificationSuccess(title, message)
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    },
    filterEmail: function () {
      for (const key in this.hotel.emailConfiguration) {
        this.hotel.emailConfiguration[key] = this.hotel.emailConfiguration[key].filter(item => item !== '')
      }
    }
  }
}
</script>

<style>
  .el-form > div {
    text-align: left;
  }
</style>
